import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { first, startWith } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { Usuario } from '../administracion/modelos';
import { Sucursal } from '../administracion/modelos/sucursal';
import { AuthenticationService, SucursalService, UsuarioService } from '../administracion/servicios';
export interface NombreSucursal {
  name: string | any;
}
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loading = false;
  returnUrl!: string;
  usuario :Usuario = new Usuario();
  error = '';
  sucursal= '';
  sucursales!: Sucursal[];
  myControl = new FormControl();
  options: NombreSucursal[] = [];
  hide = true;//PARA HACER VISIBLE O NO LA CONTRASEÑA
  conexion=false
  filteredOptions: Observable<NombreSucursal[]> | undefined;
  constructor(
      private route: ActivatedRoute,
      private activatedRoute: ActivatedRoute,
      private router: Router,
      private authenticationService: AuthenticationService,
      private sucursalService:SucursalService) {}

  ngOnInit() {

        localStorage.removeItem('currentUser');
        localStorage.removeItem('empleado');
        localStorage.removeItem('roles');
        localStorage.removeItem('sucursales');
        localStorage.removeItem('region');
        localStorage.removeItem('glpiToken');
        this.activatedRoute.params.subscribe(async (params) => {
          let usuario: any = params['usuario'] || undefined;
          let name: any = params['password'] || undefined;
          let sucursal: any = params['sucursal'] || undefined;
          console.log(usuario)
          console.log(name)
          console.log(sucursal)
          if(usuario!=undefined){
            localStorage.setItem('bandera', JSON.stringify(true));
          this.loginParametros(usuario,name,sucursal)
          }
        });


      //cierra las ventanas modales de la libreria sweetalert
      // reset login status
      //this.authenticationService.logout();

      this.sucursalService.getSucursales().subscribe(val=>{
          this.sucursales=val;
          this.sucursales.forEach(element => {
      Swal.close();

            this.conexion=false
            //   userr.name=element.username
               this.options.push({name:element.nombreSucursal})

             })
             ,(error:any)=>{
this.conexion=true
console.log("error ->"+error)

             }

      })
      // get return url from route parameters or default to '/'
      this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        map(value => (typeof value === 'string' ? value : value.name)),
        map(name => (name ? this._filter(name) : this.options.slice())),
      );
        // get return url from route parameters or default to '/'
       // this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }
    displayFn(user: NombreSucursal): string {
      return user && user.name ? user.name : '';
    }

    private _filter(name: string): NombreSucursal[] {
      const filterValue = name.toLowerCase();

      return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
    }
    loginParametros(usuario:string, pass:string,sucursal:string) {
      let variable;
      this.usuario.username=usuario
      this.usuario.password=pass
      this.loading = true;

      this.authenticationService.login(this.usuario,sucursal)
          .pipe(first())
          .subscribe(
              data => {
                let roles = JSON.parse(localStorage.getItem('roles')!);
console.log(data)
                let bandera = false;
                for(let i= 0;i<roles.roles.length;i++){

                    if(roles.roles[i].nombreTarea=="SISTEMA GESTION"){
                      localStorage.setItem('sucursalIngresa',JSON.stringify(roles.roles[i].sucursalIngresa))
                      localStorage.setItem('permisos', JSON.stringify(roles.roles[i].hijos)!);
                      bandera = true;
                    }
                }

                if(bandera){
                    this.router.navigate(['layout']);
                } else {
                    Swal.fire('Atencion',"¡No tienes acceso al sistema!\nPonte en contacto con TI.","warning")
                    this.loading = false;
                    localStorage.clear();
                }


              },
              async error => {
                console.log(error.estatus)
                if(error.status==403){
                  console.log(error.error.mensaje)
                  let a=await this.authenticationService.estado(this.usuario.username+"").toPromise()
                  if(a.estatus=="BLOQUEADO"){
                    Swal.fire('Atencion',"¡Usuario bloqueado!","warning")
                  }else
                  Swal.fire('Acceso Incorrecto',' Nombre de usuario o contraseña incorrecta',"error")
                    this.loading = false;
                  }

                  else
                  Swal.fire('Atencion',"¡No tienes permisos en esta sucursal!\nPonte en contacto con TI.","warning")
                  this.loading = false;
              });

      }
  onSubmit() {
    let variable;
    this.loading = true;

    this.authenticationService.login(this.usuario,this.myControl.value.name)
        .pipe(first())
        .subscribe(
            data => {
              console.log(data)
              let roles = JSON.parse(localStorage.getItem('roles')!);

              let bandera = false;
              for(let i= 0;i<roles.roles.length;i++){

                  if(roles.roles[i].nombreTarea=="SISTEMA GESTION"){
                    localStorage.setItem('sucursalIngresa',JSON.stringify(roles.roles[i].sucursalIngresa))
                    localStorage.setItem('permisos', JSON.stringify(roles.roles[i].hijos)!);
                    bandera = true;
                  }
              }

              if(bandera){
                  this.router.navigate(['layout']);
              } else {
                  Swal.fire('Atencion',"¡No tienes acceso al sistema!\nPonte en contacto con TI.","warning")
                  this.loading = false;
                  localStorage.clear();
              }


            },
            async error => {
              console.log(error.estatus)
              if(error.status==403){
                console.log(error.error.mensaje)
                let a=await this.authenticationService.estado(this.usuario.username+"").toPromise()
                if(a.estatus=="BLOQUEADO"){
                  Swal.fire('Atencion',"¡Usuario bloqueado!","warning")
                }else
                Swal.fire('Acceso Incorrecto',' Nombre de usuario o contraseña incorrecta',"error")
                  this.loading = false;
                }

                else
                Swal.fire('Atencion',"¡No tienes permisos en esta sucursal!\nPonte en contacto con TI.","warning")
                this.loading = false;
            });

    }
}
